import { CloseTicketParameters, closeTicket } from '@/ticket/api/close-ticket';
import { Ticket } from '@/ticket/api/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface CloseTicketOptions {
  onSuccess?: (ticket: Ticket) => void;
}

export function useCloseTicket(key: string, options?: CloseTicketOptions) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (parameters: CloseTicketParameters) => {
      return closeTicket(key, parameters);
    },
    onSuccess: async ({ ticket }) => {
      await queryClient.invalidateQueries({ queryKey: ['ticket', key] });
      options?.onSuccess?.(ticket);
    },
  });
}
